// Copyright (c) 2017 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../shared/action-creators/get-claim-types';
import actions from '../../action-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_ALL_CLAIMS_CLAIM_TYPES);



// WEBPACK FOOTER //
// ./src/claim/all-claims/action-creators/get-claim-types.js